import { processInclude } from './util/common';

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./storeLocator/storeLocator'));
});
